import { Box, Button, Card, CircularProgress, Container, InputBase, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import Iconify from 'src/components/iconify'

function ServiceDashboardPage() {

    const serviceData = [
        { id: 1, taskName: "Research", estimate: "2d 4h", spentTime: "1d 2h", assignee: "https://img.freepik.com/premium-vector/avatar-profile-icon-flat-style-male-user-profile-vector-illustration-isolated-background-man-profile-sign-business-concept_157943-38764.jpg?ga=GA1.1.535591849.1703070569&semt=ais_hybrid", priority: "Medium", value: "100" },
        { id: 2, taskName: "Mind Map", estimate: "1d 2h", spentTime: "4h 25m", assignee: "https://img.freepik.com/premium-vector/avatar-profile-icon-flat-style-male-user-profile-vector-illustration-isolated-background-man-profile-sign-business-concept_157943-38764.jpg?ga=GA1.1.535591849.1703070569&semt=ais_hybrid", priority: "Medium", value: "80" },
        { id: 3, taskName: "UX sketches", estimate: "4d", spentTime: "2d 2h 20m", assignee: "https://img.freepik.com/premium-vector/avatar-profile-icon-flat-style-male-user-profile-vector-illustration-isolated-background-man-profile-sign-business-concept_157943-38764.jpg?ga=GA1.1.535591849.1703070569&semt=ais_hybrid", priority: "Low", value: "50" },
        { id: 4, taskName: "UX Login + Registration", estimate: "2d", spentTime: "3h 15m", assignee: "https://img.freepik.com/premium-vector/avatar-profile-icon-flat-style-male-user-profile-vector-illustration-isolated-background-man-profile-sign-business-concept_157943-38764.jpg?ga=GA1.1.535591849.1703070569&semt=ais_hybrid", priority: "Low", value: "5" },
        { id: 5, taskName: "UI Login + Registration", estimate: "1d 2h", spentTime: "4h", assignee: "https://img.freepik.com/premium-vector/avatar-profile-icon-flat-style-male-user-profile-vector-illustration-isolated-background-man-profile-sign-business-concept_157943-38764.jpg?ga=GA1.1.535591849.1703070569&semt=ais_hybrid", priority: "Medium", value: "100" },
        { id: 6, taskName: "UI for other screens", estimate: "4d", spentTime: "2d 2h 20m", assignee: "https://img.freepik.com/premium-vector/avatar-profile-icon-flat-style-male-user-profile-vector-illustration-isolated-background-man-profile-sign-business-concept_157943-38764.jpg?ga=GA1.1.535591849.1703070569&semt=ais_hybrid", priority: "Low", value: "60" },
    ]

    return (
        <>
            <Helmet>
                <title>Service Dashboard</title>
            </Helmet>
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Service Dashboard
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                    </Box>
                </Stack>
                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
                    <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", paddingLeft: "200px", maxHeight: 350 }}>
                        <Table sx={{ tableLayout: "fixed", width: "100%" }}>
                            <TableBody>
                                {serviceData.map((service) => (
                                    <TableRow key={service.id} sx={{
                                        backgroundColor: "#f8fafa",
                                        borderRadius: "12px",
                                        overflow: "hidden",
                                        marginBottom: 1,
                                        display: "block"
                                    }}>
                                        <TableRow sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 16px" }}>
                                            <TableCell sx={{ display: "grid", flex: "auto", textAlign: "start", width: "150px" }}>
                                                <Typography variant="caption" color="textSecondary">Task Name</Typography>
                                                <Typography variant='caption'>{service.taskName}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ display: "grid", flex: "auto", width: "100px", textAlign: "center" }}>
                                                <Typography variant="caption" color="textSecondary">Estimate</Typography>
                                                <Typography variant='caption'>{service.estimate}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ display: "grid", flex: "auto", width: "120px", textAlign: "center" }}>
                                                <Typography variant="caption" color="textSecondary">Spent Time</Typography>
                                                <Typography variant='caption'>
                                                    {service.spentTime}
                                                </Typography>
                                            </TableCell>
                                            <TableCell sx={{ display: "grid", flex: "auto", width: "100px", textAlign: "center" }}>
                                                <Typography variant="caption" color="textSecondary">Assignee</Typography>
                                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                    <img src={service.assignee} alt='Image.png' style={{ width: "30px", height: "30px", borderRadius: "50%" }} />
                                                </Box>
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    display: "grid",
                                                    flex: "auto",
                                                    width: "120px",
                                                    textAlign: "center",
                                                    color: service.priority === "Medium" ? "#FFAB0F" : "#0AC947"
                                                }}
                                            >
                                                <Typography variant="caption" color="textSecondary">
                                                    Priority
                                                </Typography>
                                                <Typography variant='caption'><Iconify
                                                    icon={service.priority === "Medium"
                                                        ? "material-symbols:arrow-upward-rounded"  // Up arrow for Medium
                                                        : "material-symbols:arrow-downward-rounded"} // Down arrow for Low
                                                    sx={{ margin: "-5px", marginRight: "3px" }}
                                                />
                                                    {service.priority}</Typography>
                                            </TableCell>

                                            <TableCell sx={{ flex: 1, width: "100px", textAlign: "center" }}>
                                                <Button variant="contained" size="small" sx={{
                                                    color: "#00D097",
                                                    backgroundColor: "#E0F9F2",
                                                    fontSize: "12px",
                                                    "&:hover": {
                                                        backgroundColor: "#C8F5E6",
                                                    }
                                                }}>
                                                    Done
                                                </Button>
                                            </TableCell>
                                            <TableCell sx={{ display: "grid", flex: "auto", width: "100px", textAlign: "center", cursor: "pointer" }}>
                                                <CircularProgress variant="determinate" value={service.value} />
                                            </TableCell>
                                        </TableRow>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            </Container>
        </>
    )
}

export default ServiceDashboardPage
